import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// 修正图片导入名称（原"tset1"改为"test1"）
import test1 from "../assets/iog.jpg";
import test2 from "../assets/jesm.png";
import test3 from "../assets/zpbr.png";
import Message from "../components/Message";

const ArchivePage = () => {
  const [message, setMessage] = useState(null);
  // 替换为包含图片的期刊数据，移除isComingSoon状态
  const allJournals = [
    {
      id: "journal-1",
      journal: "Journal-1",
      title: "Journal 1 Archive",
      year: "2024",
      issues: ["Issue 1", "Issue 2"], // 可根据实际需求补充期数
      cover_image: test1, // 关联test1图片
      isComingSoon: false,
    },
    {
      id: "journal-2",
      journal: "Journal-2",
      title: "Journal 2 Archive",
      year: "2024",
      issues: ["Issue 1"],
      cover_image: test2, // 关联test2图片
      isComingSoon: false,
    },
    {
      id: "journal-3",
      journal: "Journal-3",
      title: "Journal 3 Archive",
      year: "2023",
      issues: ["Issue 3", "Issue 4"],
      cover_image: test3, // 关联test3图片
      isComingSoon: false,
    }
  ];

  const showMessage = (content) => {
    setMessage(content);
    setTimeout(() => setMessage(null), 2000); // 2秒后消失
  };

  return (
    <>
      {message && <Message content={message} onClose={() => setMessage(null)} />}
      <div>
        <div className="row">
          <div className="col-12">
            <div className="page-title">
              <h1>Journal Archive</h1>
            </div>
            <div className="row">
              {allJournals.map((journal, index) => {
                const gradientDirections = [
                  "at bottom right",
                  "at top left",
                  "at top right",
                  "at bottom left",
                ];
                const direction = gradientDirections[index % gradientDirections.length];

                return (
                  <div key={journal.id} className="col-md-3 mb-3">
                    <div
                      className="card card-tab p-0 shadow-sm hover:shadow-md transition-shadow duration-300"
                      style={{
                        cursor: "pointer",
                        background: journal.cover_image 
                          ? "#fff" 
                          : `radial-gradient(${direction}, #495057 40%, #003366 100%)`,
                        border: journal.cover_image ? "1px solid rgba(0,0,0,.125)" : "none",
                      }}
                      onClick={() => showMessage(`In Preparation`)}
                    >
                      <div className="card-body p-0">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          {journal.cover_image ? (
                            <img
                              src={journal.cover_image}
                              alt={journal.journal}
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover", // 保持图片比例，填充容器
                              }}
                            />
                          ) : (
                            <div className="text-center text-white">
                              <div
                                style={{
                                  marginBottom: "1rem",
                                  fontWeight: 600,
                                  fontSize: "1.1rem",
                                }}
                              >
                                {journal.journal}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const VolumeCard = ({ volume }) => {
  return (
    <div className="card shadow-sm hover:shadow-md d-flex">
      <Row>
        <Col xs={12} md={6}>
          <div className="card-img-container p-3">
            <div className="volume-stats mb-3 d-flex justify-center">
              <div
                style={{
                  height: "300px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "5px",
                  overflow: "hidden",
                }}
              >
                {/* 若VolumeCard需显示图片，可通过volume.cover_image扩展 */}
                {volume.cover_image ? (
                  <img
                    src={volume.cover_image}
                    alt={volume.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <div style={{ fontSize: "3rem", color: "#6c757d" }}>...</div>
                )}
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className="card-body d-flex flex-column" style={{ flex: "1" }}>
            <div className="issues-list">
              <h5 className="card-title">{volume.title || "More Journal"}</h5>
              <p className="card-text text-muted" style={{ margin: "0" }}>
                {volume.description || "Journal archive details"}
              </p>
              <small className="text-muted mt-2 d-block">
                <i className="fas fa-calendar-alt me-1"></i>
                Year: {volume.year || "Coming Soon"}
              </small>
              <br />
              <small className="text-muted">
                <i className="fas fa-book me-1"></i>
                Issues: {volume.issues?.length || 0}
              </small>
              {/* 新增查看按钮（可选） */}
              {volume.issues?.length > 0 && (
                <Button variant="primary" size="sm" className="mt-3 w-100">
                  View Issues
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ArchivePage;